<template>
  <footer class="main-footer cyber-footer">
    <div class="d-flex justify-content-between align-items-center flex-wrap">
      <div class="cyber-footer__copy">
        <span class="cyber-footer__logo">BC</span>
        &copy; 2025 <a href="#">Business Club</a>. All Rights Reserved.
      </div>
      <div class="d-none d-sm-flex align-items-center">
        <ul class="nav nav-primary nav-dotted nav-dot-separated justify-content-end mb-0">
          <li class="nav-item">
            <a class="nav-link cyber-footer__link" href="javascript:void(0)">FAQ</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.cyber-footer {
  font-size: 0.8rem;
}

.cyber-footer__copy {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #9A998F;
}

.cyber-footer__logo {
  font-family: 'Orbitron', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  color: #B09A4E;
  border: 1px solid rgba(176, 154, 78, 0.3);
  padding: 2px 6px;
  border-radius: 4px;
  letter-spacing: 0.1em;
}

.cyber-footer__link {
  color: #9A998F !important;
  font-size: 0.8rem;
  transition: all 0.2s ease;
}

.cyber-footer__link:hover {
  color: #B09A4E !important;
}
</style>

<script>
export default {
  name: "footer-menu"
};
</script>
